export default __webpack_public_path__ + "static/img/external5.aff74b8.jpg";